import { NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';
import { SetupComponent } from './setup/setup.component';
import { AccountRoutes } from './account.routes';
import { SharedModule } from '../shared/shared.module';
import { Ng5SliderModule } from 'ng5-slider';
import { SignupComponent } from './signup/signup.component';
import { SignupForm } from './signup/signup.form';
import { SetupForm } from './setup/setup.form';
import { ConfirmComponent } from './confirm/confrm.component';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha';
import { environment } from '../../environments/environment';


@NgModule({
  declarations: [
    SetupComponent,
    SignupComponent,
    ConfirmComponent
  ],
  imports: [
    RouterModule.forChild(AccountRoutes),
    SharedModule,
    Ng5SliderModule,
    RecaptchaModule,
    RecaptchaFormsModule
  ],
  providers: [
    SignupForm,
    SetupForm,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.recaptcha.siteKey } as RecaptchaSettings,
    },
  ]
})
export class AccountModule {

}
